import React from "react";
import DebounceInput from "react-debounce-input";

const Comments = ({ handleAddComments }) => {
  const onAddComments = (event) => {
    handleAddComments(event.target.value);
  };

  return (
    <div className="review-comments">
      <h3 className="review-comments__header">Special Comments</h3>
      <DebounceInput
        element="textarea"
        className="review-comments__textarea"
        name="special_comments"
        id="special_comments"
        cols="30"
        rows="10"
        debounceTimeout={300}
        onChange={onAddComments}
      />
    </div>
  );
};

export default Comments;
